







import { Component, Vue } from "vue-property-decorator";
@Component({
  name: "app-main",
  components: {}
})
export default class TFTHeader extends Vue {
  created() {
    this.$vuetify.theme.dark = true;
  }
}
